import {CreateThirdPartyTag, ThirdPartyTagId, ThirdPartyTagMin} from "../../Types";
import {invalidateQueries, q} from "../../state";
import {CURRENT_REGION} from "../../utils/region";
import jsonApi from "../jsonApi";

export async function list(): Promise<ThirdPartyTagMin[]> {
  return await jsonApi.get<ThirdPartyTagMin[]>(`/region/${CURRENT_REGION}/api/tprm/third_party_tags`);
}

export async function create(tag: CreateThirdPartyTag) {
  const res = await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/tprm/third_party_tags`, tag);
  await invalidateQueries([q.tprm.thirdPartyTags.filter()]);
  return res;
}

export async function updateTitle(tagId: ThirdPartyTagId, title: string) {
  const res = await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/tprm/third_party_tags/${tagId}/title`, title);
  await invalidateQueries([q.tprm.thirdPartyTags.filter()]);
  return res;
}

export async function updateColor(tagId: ThirdPartyTagId, color: string) {
  const res = await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/tprm/third_party_tags/${tagId}/color`, color);
  await invalidateQueries([q.tprm.thirdPartyTags.filter()]);
  return res;
}

export async function delete_(tagId: ThirdPartyTagId) {
  const res = await jsonApi.delete_<"ok">(`/region/${CURRENT_REGION}/api/tprm/third_party_tags/${tagId}`);
  await invalidateQueries([q.tprm.thirdPartyTags.filter()]);
  return res;
}
